/**
 * Include your custom JavaScript here.
 */

/* Aquipond : inclure les articles de blog et les pages dans la recherche instantanée du header */
(function () {
  if (!window.fetch || window.__aqSuggestPatched) return;
  window.__aqSuggestPatched = true;
  var orig = window.fetch;
  window.fetch = function (input, init) {
    try {
      var u = typeof input === 'string' ? input : (input && input.url);
      if (u && u.indexOf('/search/suggest') !== -1 && u.indexOf('resources%5Btype%5D') === -1 && u.indexOf('resources[type]') === -1) {
        u += (u.indexOf('?') === -1 ? '?' : '&') + 'resources[type]=product,article,collection,page,query';
        input = typeof input === 'string' ? u : new Request(u, input);
      }
    } catch (e) {}
    return orig.call(this, input, init);
  };
})();
